import React from 'react'
import Calendar from './Calendar'
import GraphDetailContent from './GraphDetailContent'
import './../assets/table.css'
import closeIcon from '../images/closeIcon.svg'
// import arrowDownIcon from '../images/arrowDownIcon.svg'
import momentTimezone from 'moment-timezone'
import moment from 'moment'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  STATE_CREATED_OF_CURRENT_DAY_BY_VEHICLE,
  STATE_OF_SELECTED_DAY_BY_VEHICLE,
  STATE_OF_SELECTED_MONTH_BY_VEHICLE, 
  METRICS_BY_DATE,
  METRICS_EVENT_DATE
} from '../query/metric'
import { client } from '../graphql/client'
import CircularProgress from '@material-ui/core/CircularProgress'
import {omegaClient} from '../graphql/omegaClient'
moment.locale('fr')

let day = new Date()
day.setHours(0, 0, 0, 0)

let month = new Date()
month.setHours(0, 0, 0, 0)

class GraphDetailComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedDay: props.metrics && props.metrics.length > 0 ? moment(new Date()).format('YYYY-MM-DD') : undefined,
      selectedMonth: month,
      data: this.objectToArray(props.metrics),
      dataOfSelectedMonth: null,
      dataOfSelectedDay: null,
      isCurrentDay: true,
      dateList: null,
      loadingDayData: false
    }
  }

  // UNSAFE_componentWillMount () {
  //   this.getDataOfSelectedMonth(this.state.selectedMonth)
  // }

  // getDataOfSelectedMonth (selectedMonth) {
  //   const self = this
  //   var startMonth = moment([selectedMonth.getFullYear(), selectedMonth.getMonth()]).toDate()
  //   var endMonth = moment([selectedMonth.getFullYear(), selectedMonth.getMonth()]).endOf('month').toDate()
  //   startMonth = moment(startMonth).format('YYYY-MM-DD')
  //   endMonth = moment(endMonth).format('YYYY-MM-DD')
  //   var token = localStorage.getItem('token')
  //   getUserInfo(token)
  //     .then(response => response.json())
  //     .then(function (data) {
  //       if (data.error && data.error.code === 401) {
  //         refreshToken(localStorage.getItem('refresh_token'))
  //       }
  //       // client
  //       //   .query({
  //       //     query: STATE_OF_SELECTED_MONTH_BY_VEHICLE,
  //       //     variables: { sensor: `TRACK:${self.props.trackableId}`, startMonth: startMonth, endMonth: endMonth }
  //       //   })
  //       //   .then(result => {
  //       //     let metrics = result.data.dates_with_value_by_sensor
  //       //     self.setState({
  //       //       dataOfSelectedMonth: metrics
  //       //     })
  //       //   }).catch(error => console.log(error))
  //     })
  //     .catch((error) => {
  //       console.log('error: ', error)
  //     })
  // }

  metricsEventDate (trackableLabel) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: METRICS_EVENT_DATE,
          variables: { trackable_label: trackableLabel },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.metrics_date_month)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  componentDidMount () {
    this.metricsEventDate(this.props.trackableLabel)
      .then((eventDates) => {
        const dateList = eventDates.map(metric => new Date(metric.date))
        this.setState({ dateList })
      })
      .catch((error) => {
        console.log('error fetching month dates', error)
      })
  }

  objectToArray (obj) {
    let data = []
    for (var i = 0; i < obj.length; i++) {
      if (i === 0) {
        data.push([momentTimezone.utc(obj[0]['occurred_at']).tz('Indian/Antananarivo').valueOf(), Number(obj[0]['value'])])
      } else if (i < obj.length - 1) {
        if (Number(obj[i]['value']) !== Number(obj[i - 1]['value'])) {
          data.push([momentTimezone.utc(obj[i]['occurred_at']).tz('Indian/Antananarivo').valueOf(), Number(obj[i]['value'])])
        }
      } else {
        data.push([momentTimezone.utc(obj[i]['occurred_at']).tz('Indian/Antananarivo').valueOf(), Number(obj[i]['value'])])
      }
    }
    return data
  }

  onMonthChange (month) {
    this.setState({
      selectedMonth: month
    })
  }

  getDateInData (data) {
    let dateList = []
    data.forEach(function (element) {
      dateList.push(new Date(momentTimezone.utc(element.date).tz('Indian/Antananarivo')))
    })
    return dateList
  }

  getFormattedDateList (data) {
    let formattedDateList = []
    if (data) {
      data.forEach(function (element) {
        formattedDateList.push(momentTimezone.utc(element.date).tz('Indian/Antananarivo').format('YYYY-MM-DD'))
      })
    }
    return formattedDateList
  }

  // getDateList () {
  //   // Get current date
  //   const currentDate = new Date()
  //   currentDate.setHours(0, 0, 0, 0)
  //   const dateList = []

  //   // Generate dates for 45 days before current date
  //   for (let i = 0; i < 45; i++) {
  //     const date = new Date(currentDate)
  //     date.setDate(currentDate.getDate() - i)
  //     dateList.push(date)
  //   }

  //   return dateList
  // }

  metricsByDate (trackableLabel, date) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: METRICS_BY_DATE,
          variables: { trackable_label: trackableLabel, date },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.metrics_by_date)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  handleDayClick (day, selected) {
    const self = this
    let formattedDate = moment(day).format('YYYY-MM-DD')

    if (formattedDate !== self.state.selectedDay) {
      // Set loading state
      self.setState({ selectedDay: formattedDate, loadingDayData: true })

      self.metricsByDate(self.props.trackableLabel, formattedDate)
        .then((metricsByDate) => {
          // Filter metrics to only include those where occurred_at is on the same day as formattedDate
          const filteredMetrics = metricsByDate.filter((metric) => {
            if (metric.occurred_at && metric.value) {
              const metricDate = moment(metric.occurred_at).format('YYYY-MM-DD')
              return metricDate === formattedDate
            }
            return false
          })

          self.setState({
            dataOfSelectedDay: self.objectToArray(filteredMetrics),
            loadingDayData: false
          })
        })
        .catch((error) => {
          console.log('error fetching metrics by date', error)
          self.setState({ loadingDayData: false })
        })
    }
  }

  renderGraphDetailContent () {
    let selectedDay = this.state.selectedDay
    let formattedSelectedDay = moment(selectedDay).format('MM/DD/YYYY')
    let formattedCurrentDay = moment(new Date()).format('MM/DD/YYYY')

    // Show loading spinner when fetching day data
    if (this.state.loadingDayData) {
      return (
        <div style={{ height: '640px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#364248', borderRadius: '3px', marginTop: '22px' }}>
          <CircularProgress style={{ color: '#7ED321' }} color='inherit' />
        </div>
      )
    }

    if (selectedDay && formattedSelectedDay !== formattedCurrentDay) {
      return (
        <GraphDetailContent
          data={this.state.dataOfSelectedDay}
          tankCapacity={this.props.tankCapacity}
          trbImm={this.props.trbImm}
          selectedDay={selectedDay}
        />
      )
    }
    return (
      <GraphDetailContent
        data={this.state.data}
        tankCapacity={this.props.tankCapacity}
        trbImm={this.props.trbImm}
        selectedDay={selectedDay}
      />
    )
  }

  render () {
    const selectedDayAsDate = this.state.selectedDay ? new Date(this.state.selectedDay) : undefined
    const vehicleDisplayMode = localStorage.getItem('vehicleDisplayMode') || 'registration'
    const displayValue = vehicleDisplayMode === 'registration' ? this.props.trbImm : this.props.trackableName

    return (
      <div style={styles.container}>
        <div style={styles.contentIcon}>
          <img
            src={closeIcon}
            width='16px'
            height='16px'
            alt='true'
            onClick={this.props.onClose}
          />
        </div>
        <div style={styles.contentGraph}>
          <div style={styles.leftContent}>
            <div>
              <span style={styles.modalTitle}>{displayValue}</span>
            </div>
            <div>
              {this.renderGraphDetailContent()}
            </div>
          </div>
          <div style={styles.rightContent}>
            {this.state.dateList
              ? <Calendar
                initialMonth={this.state.selectedMonth}
                onMonthChange={(month) => this.onMonthChange(month)}
                selectedDay={selectedDayAsDate}
                dateList={this.state.dateList}
                handleDayClick={(day, selected) => this.handleDayClick(day, selected)}
              />
              : <CircularProgress style={{ color: '#7ED321', marginLeft: '128px', marginTop: '192px', marginBottom: '174px' }} color='inherit' />
            }
            {/* <div style={styles.contentButton}>
              <button style={styles.button}
                onClick={this.props.upload}>
                <span style={styles.label}>TELECHARGER LE GRAPHE</span>
                <img
                  style={styles.icon}
                  src={arrowDownIcon}
                  alt='true'
                />
              </button>
            </div> */}
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    width: '1320px'
  },
  contentIcon: {
    marginTop: '-52px',
    float: 'right',
    cursor: 'pointer'
  },
  contentGraph: {
    width: '1320px',
    marginBottom: '50px'
  },
  leftContent: {
    float: 'left',
    width: '966px',
    marginBottom: '10px'
  },
  rightContent: {
    float: 'right',
    marginLeft: '34px',
    width: '312px'
  },
  modalTitle: {
    fontWeight: 321,
    fontSize: '32px',
    color: '#F2F2F2'
  },
  contentButton: {
    height: '48px',
    width: '312px'
  },
  button: {
    marginLeft: '5px',
    cursor: 'pointer',
    paddingTop: '7px',
    marginTop: '24px',
    height: '38px',
    width: '302px',
    borderRadius: '19px',
    border: 'none',
    backgroundColor: '#2C343A'
  },
  label: {
    textAlign: 'center',
    color: '#748591',
    marginLeft: '2px',
    fontSize: '13px',
    fontWeight: 600
  },
  icon: {
    marginTop: '-7px',
    marginRight: '-2px',
    float: 'right',
    marginLeft: '6px'
  }
}

export default GraphDetailComponent
